import { render } from "./SuggestionsPopover.vue?vue&type=template&id=5e1352c0&scoped=true&lang=pug"
import script from "./SuggestionsPopover.vue?vue&type=script&lang=js"
export * from "./SuggestionsPopover.vue?vue&type=script&lang=js"

import "./SuggestionsPopover.vue?vue&type=style&index=0&id=5e1352c0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1352c0"]])

export default __exports__